import React from "react";
import { Button } from "../../../../ui/components/Button";
import { CashBankPaymentSummaryEntity } from "../../domain";
import { formatCashBankAmount } from "../utils/cashBankFormatters";

interface CashBankSummaryCardsProps {
  customerSummary: CashBankPaymentSummaryEntity;
  vendorSummary: CashBankPaymentSummaryEntity;
  loading?: boolean;
  onViewCustomerPending: () => void;
  onViewVendorPending: () => void;
}

const SummaryValueSkeleton: React.FC<{ className?: string }> = ({
  className = "",
}) => (
  <div className={`h-8 rounded bg-neutral-100 animate-pulse ${className}`} />
);

export const CashBankSummaryCards: React.FC<CashBankSummaryCardsProps> = ({
  customerSummary,
  vendorSummary,
  loading = false,
  onViewCustomerPending,
  onViewVendorPending,
}) => {
  return (
    <div className="flex w-full flex-wrap items-start gap-4">
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border px-6 py-6">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Pending Customer Payments
        </span>
        <div className="flex w-full items-end justify-between">
          <div className="flex flex-col items-start gap-1">
            <span className="text-body font-body text-subtext-color">Count</span>
            {loading ? (
              <SummaryValueSkeleton className="w-16" />
            ) : (
              <span className="text-heading-2 font-heading-2 text-default-font">
                {customerSummary.count}
              </span>
            )}
          </div>
          <div className="flex flex-col items-start gap-1">
            <span className="text-body font-body text-subtext-color">Amount</span>
            {loading ? (
              <SummaryValueSkeleton className="w-36" />
            ) : (
              <span className="text-heading-2 font-heading-2 text-success-600">
                {formatCashBankAmount(customerSummary.total_amount)}
              </span>
            )}
          </div>
        </div>
        <Button size="small" onClick={onViewCustomerPending} disabled={loading}>
          View Pending
        </Button>
      </div>
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border px-6 py-6">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Pending Vendor Payments
        </span>
        <div className="flex w-full items-end justify-between">
          <div className="flex flex-col items-start gap-1">
            <span className="text-body font-body text-subtext-color">Count</span>
            {loading ? (
              <SummaryValueSkeleton className="w-16" />
            ) : (
              <span className="text-heading-2 font-heading-2 text-default-font">
                {vendorSummary.count}
              </span>
            )}
          </div>
          <div className="flex flex-col items-start gap-1">
            <span className="text-body font-body text-subtext-color">Amount</span>
            {loading ? (
              <SummaryValueSkeleton className="w-36" />
            ) : (
              <span className="text-heading-2 font-heading-2 text-error-600">
                -{formatCashBankAmount(vendorSummary.total_amount)}
              </span>
            )}
          </div>
        </div>
        <Button size="small" onClick={onViewVendorPending} disabled={loading}>
          View Pending
        </Button>
      </div>
    </div>
  );
};
